<div class="message-page-container">
  <div class="message-page-message">
    @if (talentName) {
      <div>
        <h3>{{"talent-happy-path.quick-apply.welcome-page.title" | translate}} {{talentName}}</h3>
        <p>{{"talent-happy-path.quick-apply.welcome-page.continue-message" | translate}}</p>
      </div>
    }
  </div>
  <a id="welcome-back-continue-button"
     mat-flat-button color="primary"
     class="custom-button single-custom-button message-page-button"
     (click)="clickContinue()">
    {{"talent-happy-path.quick-apply.continue" | translate}}
  </a>
</div>
